const DBName = 'infoV';
const storaName = 'inspection-photos';
let db: any = null;
let dbReady: Promise<any> | null = null;

class IndexedDB {
  public createdDB(): Promise<any> {
    if (db) return Promise.resolve(db);
    if (dbReady) return dbReady;

    dbReady = new Promise((resolve, reject) => {
      if (!window.indexedDB) {
        console.error('Create IndexedDB', 'no suppot');
        reject(new Error('IndexedDB not supported'));
        return;
      }

      const request = window.indexedDB.open(DBName, 1);

      request.onsuccess = (e: any) => {
        db = e.target.result;
        resolve(db);
      }

      request.onerror = (e: any) => {
        console.error(e);
        dbReady = null;
        reject(e);
      }

      request.onupgradeneeded = (event: any) => {
        if (!event || !event.target) return;

        db = event.target.result;

        const objStore = db
          .createObjectStore(storaName,
            {
              keyPath: 'id',
              autoIncrement: true
            });
        objStore.createIndex('plate', 'plate', { unique: false });
        objStore.createIndex('unique_identifier', 'unique_identifier', { unique: false });
        objStore.createIndex('create_date', 'create_date', { unique: false });
        objStore.createIndex('status', 'status', { unique: false });
        objStore.createIndex('photo', 'photo', { unique: false });
        objStore.createIndex('applet_subgroup_id', 'applet_subgroup_id', { unique: false });
        objStore.createIndex('accuracy', 'accuracy', { unique: false });
        objStore.createIndex('latitude', 'latitude', { unique: false });
        objStore.createIndex('longitude', 'longitude', { unique: false });
      }
    });

    return dbReady;
  }

  public async addData(data: any) {
    const database = await this.createdDB();
    return new Promise((resolve, reject) => {
      const transaction = database.transaction(storaName, 'readwrite');
      const objStore = transaction.objectStore(storaName);

      const request = objStore.add(data);
      request.onsuccess = (event: any) => {
        resolve(event.target.result);
      }

      request.onerror = (error: any) => {
        console.error(error);
        reject(error);
      }
    });
  }

  public async update(data: any) {
    const database = await this.createdDB();
    return new Promise((resolve, reject) => {
      const transaction = database.transaction(storaName, 'readwrite');
      const objStore = transaction.objectStore(storaName);

      const updateRequest = objStore.put(data);
      updateRequest.onsuccess = (event: any) => {
        resolve(event.target.result);
      }

      updateRequest.onerror = (e: any) => {
        reject(e);
      }
    });
  }

  public async getData() {
    return this.getAll();
  }

  public async getByProperty(property: string, value: string) {
    const all: any[] = await this.getAll() as any[];
    return all.filter((item: any) => item[property] === value);
  }

  public async getAll() {
    const database = await this.createdDB();
    return new Promise((resolve, reject) => {
      const transaction = database.transaction(storaName);
      const objStore = transaction.objectStore(storaName);

      const request = objStore.getAll();

      request.onsuccess = () => {
        resolve(request.result);
      }

      request.onerror = (e: any) => {
        reject(e);
      }
    })
  }

  public async removeData(itemId: number) {
    const database = await this.createdDB();
    return new Promise((resolve, reject) => {
      const transaction = database.transaction(storaName, 'readwrite');
      const objStore = transaction.objectStore(storaName);

      objStore.delete(itemId);

      transaction.oncomplete = () => resolve(undefined);
      transaction.onerror = (e: any) => reject(e);
      transaction.onabort = (e: any) => reject(e);
    })
  }

  public async deleteAllSentRegister(keepIdentifiers: string[] = []) {
    const sentRegisters: any[] = await this.getByProperty('status', 'SENT') as any[];
    const allSents = sentRegisters
      .filter((sent: any) => !keepIdentifiers.includes(sent.unique_identifier));

    if (!allSents.length) return;

    await Promise.all(allSents.map((sent: any) => this.removeData(sent.id)));
  }

  public closeConnection() {
    if (db) {
      db.close();
      db = null;
      dbReady = null;
    }
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new IndexedDB();
